import { TextStyle } from "pixi.js";
import { GameFont } from "../../../../common/GameFont";
import { CommonResourcesPackage } from "../../../../common/resources/CommonResourcesPackage";
import { VictoryResourcesPackage } from "../resources/VictoryResourcesPackage";
import { AnimatedRewardContainer } from "./AnimatedRewardContainer";
import { SpineResourcesPackage } from "../../../../common/resources/SpineResourcesPackage";

export class VegetablesReward extends AnimatedRewardContainer {
    private static readonly VEGETABLES_FORMAT = "{0}/{1}";

    public constructor(
        commonResources: CommonResourcesPackage,
        spineResources: SpineResourcesPackage,
        victoryResources: VictoryResourcesPackage,
        collected: number,
        totalCount: number
    ) {
        super(
            victoryResources.assets_popups_victory_vegetables_reward_substrate_png,
            commonResources.assets_common_vegetables_icon_png,
            VegetablesReward.VEGETABLES_FORMAT.replace("{0}", collected.toString()).replace("{1}", totalCount.toString()),
            new VegetablesTextStyle(),
            (spineResources.assets_spine_coin_coin_glow_json as any).spineData,
            124
        );
        this.text.position.set(134, 23);
    }
}

class VegetablesTextStyle extends TextStyle {
    public constructor() {
        super({
            fontSize: 40,
            fill: "#FFFFFF",
            fontFamily: GameFont.Default,
            dropShadow: true,
            dropShadowColor: "#7500d4",
            dropShadowBlur: 0.5,
            dropShadowDistance: 4,
            dropShadowAngle: 1.77
        });
    }
}
